import React from 'react'
import NotificationsListing from 'components/notifications/NotificationsListing'
import './Notifications.scss'

function Notifications() {
  return <NotificationsListing />
}

export default Notifications
